import { render, staticRenderFns } from "./pending_api.vue?vue&type=template&id=3631c488"
import script from "./pending_api.js?vue&type=script&lang=js&external"
export * from "./pending_api.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports